__turbopack_context__.v({
  "logo": "MotorwayModal-module__jNRZha__logo",
  "modalTitle": "MotorwayModal-module__jNRZha__modalTitle",
  "modalWrapper": "MotorwayModal-module__jNRZha__modalWrapper",
  "redirectError": "MotorwayModal-module__jNRZha__redirectError",
  "uspList": "MotorwayModal-module__jNRZha__uspList",
  "uspListRow": "MotorwayModal-module__jNRZha__uspListRow",
});
